import { render, staticRenderFns } from "./questionnaireFinished.vue?vue&type=template&id=52977f68&scoped=true"
import script from "./questionnaireFinished.vue?vue&type=script&lang=js"
export * from "./questionnaireFinished.vue?vue&type=script&lang=js"
import style0 from "./questionnaireFinished.vue?vue&type=style&index=0&id=52977f68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52977f68",
  null
  
)

export default component.exports